import { from } from 'rxjs';
import { filter, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import {
  isRelevantAction,
  isTrackable,
} from '@bridebook/web/lib/track-utils/epics/filter-cordova-track-actions';
import { ignore } from '@bridebook/web/lib/track-utils/with-inner-stream';
import { IEpic } from '@bridebook/web/lib/types';
import { sendTrackingEvent } from './send-tracking-event';

/**
 * Cordova tracking epic is using cordovaTracker service. Whenever a tracking event is dispatch
 * with cordovaTracker.track method, it is handled inside this epic by obtaining an event name and
 * data accordingly to the Appsflyer requirements.
 */

export const trackCordovaEpic: IEpic = (_, { cordovaTracker, state$ }) =>
  ignore(
    cordovaTracker.actions().pipe(
      filter(isRelevantAction),
      withLatestFrom(state$),
      switchMap((actionAndState) =>
        from(isTrackable(actionAndState)).pipe(
          filter((trackable) => trackable),
          map(() => actionAndState),
          tap(sendTrackingEvent),
        ),
      ),
    ),
  );
